import { Link } from './link';
import { Badge } from './badge';
import { Button } from './button';

export const components = {
  Badge,
  Button,
  Link,
};
